import React, { useMemo } from 'react';
import { generateHeatmapData } from '../data/mockData';

const Heatmap = () => {
  const data = useMemo(() => generateHeatmapData(), []);
  
  // Group by weeks for a GitHub-style layout (simplified for demo)
  const weeks = [];
  for (let i = 0; i < data.length; i += 7) {
    weeks.push(data.slice(i, i + 7));
  }

  return (
    <div className="glass-panel rounded-2xl p-6">
      <div className="flex justify-between items-center mb-4">
        <div>
          <h3 className="text-sm font-semibold text-gray-200">Consistency Grid</h3>
          <p className="text-xs text-gray-500">Last 30 days of emotional tracking</p>
        </div>
        <div className="text-right">
          <span className="text-2xl font-bold text-gradient">83%</span>
          <p className="text-xs text-gray-500">Coverage</p>
        </div>
      </div>

      <div className="flex gap-1 overflow-x-auto pb-2 scrollbar-hide">
        {weeks.map((week, wIndex) => (
          <div key={wIndex} className="flex flex-col gap-1">
            {week.map((day, dIndex) => (
              <div 
                key={dIndex}
                className={`w-6 h-6 rounded-sm ${day.color} transition-all hover:scale-110 cursor-pointer`}
                title={`${new Date(day.date).toLocaleDateString()}: Intensity ${day.intensity}`}
              />
            ))}
          </div>
        ))}
      </div>
      
      <div className="flex items-center justify-end gap-2 mt-4 text-xs text-gray-500">
        <span>Less</span>
        <div className="flex gap-1">
          <div className="w-3 h-3 rounded-sm bg-ink-700"></div>
          <div className="w-3 h-3 rounded-sm bg-aurora/25"></div>
          <div className="w-3 h-3 rounded-sm bg-aurora/50"></div>
          <div className="w-3 h-3 rounded-sm bg-aurora/75"></div>
          <div className="w-3 h-3 rounded-sm bg-aurora"></div>
        </div>
        <span>More</span>
      </div>
    </div>
  );
};

export default Heatmap;